import { Link } from "react-router-dom";
import { Phone, Mail, Instagram, Linkedin, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CONTACT } from "@/lib/data";

export const Footer = () => (
  <footer className="bg-[#0B132B] text-[#F9F6F0] relative overflow-hidden grain">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-5">
          <Logo light />
          <p className="mt-6 text-[#F9F6F0]/60 font-light leading-relaxed max-w-sm">
            Life insurance & retirement strategies built around your family.
            Money that grows without market risk — a plan you can't outlive.
          </p>
          <div className="flex gap-3 mt-8">
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram"
              className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center transition-all duration-300 hover:bg-[#29ABE2] hover:border-[#29ABE2] hover:scale-110"
            >
              <Instagram size={18} />
            </a>
            <a
              href={CONTACT.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin-link"
              aria-label="LinkedIn"
              className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center transition-all duration-300 hover:bg-[#29ABE2] hover:border-[#29ABE2] hover:scale-110"
            >
              <Linkedin size={18} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-5">
            Explore
          </h4>
          <ul className="space-y-3">
            {[
              { to: "/", label: "Home" },
              { to: "/products", label: "Products" },
              { to: "/business", label: "For Business Owners" },
              { to: "/about", label: "About" },
              { to: "/careers", label: "Careers" },
              { to: "/quote", label: "Get a Quote" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/ /g, "-")}`}
                  className="text-[#F9F6F0]/70 hover:text-white transition-colors inline-flex items-center gap-1 group"
                >
                  {l.label}
                  <ArrowUpRight
                    size={13}
                    className="opacity-0 group-hover:opacity-100 transition-opacity"
                  />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-sm tracking-[0.2em] uppercase text-[#29ABE2] font-semibold mb-5">
            Contact
          </h4>
          <ul className="space-y-4">
            <li>
              <a
                href={CONTACT.phoneHref}
                data-testid="footer-phone-link"
                className="flex items-center gap-3 text-[#F9F6F0]/70 hover:text-white transition-colors"
              >
                <Phone size={16} className="text-[#29ABE2]" /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${CONTACT.email}`}
                data-testid="footer-email-link"
                className="flex items-center gap-3 text-[#F9F6F0]/70 hover:text-white transition-colors break-all"
              >
                <Mail size={16} className="text-[#29ABE2] shrink-0" /> {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 md:mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-[#F9F6F0]/50">
        <p>Copyright © 2023 Breeze Financial Group (Breeze Wealth Management LLC). All rights reserved.</p>
        <p>Protecting families. Building generational wealth.</p>
      </div>
    </div>
  </footer>
);
